import { erpAxios } from '.';

const getStatusiZaposlenja= async () => {
  const { data } = await erpAxios.get('/gr-status-komitent/statusZaposlenja');
  return data;
};

export default getStatusiZaposlenja;